/* ==========================================================================
   PUFF LAND — JavaScript du thème (vanilla, sans dépendance)
   ========================================================================== */
(function () {
  'use strict';

  var PL = window.PuffLand || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var on = function (el, ev, fn, opt) { if (el) el.addEventListener(ev, fn, opt); };

  /* ---------- Utilitaires ---------- */
  function formatMoney(cents) {
    var fmt = PL.moneyFormat || '{{amount_with_comma_separator}} €';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var thousands = function (n, sep) { return n.replace(/\B(?=(\d{3})+(?!\d))/g, sep); };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount': return thousands(parts[0], ',') + '.' + parts[1];
        case 'amount_no_decimals': return thousands(Math.round(cents / 100).toString(), ',');
        case 'amount_with_comma_separator': return thousands(parts[0], '.') + ',' + parts[1];
        case 'amount_no_decimals_with_comma_separator': return thousands(Math.round(cents / 100).toString(), '.');
        case 'amount_with_space_separator': return thousands(parts[0], ' ') + ',' + parts[1];
        default: return thousands(parts[0], ' ') + ',' + parts[1];
      }
    });
  }

  var toastTimer;
  function toast(msg) {
    var t = $('#Toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-visible'); }, 2600);
  }

  function storage(key, val) {
    try {
      if (val === undefined) return JSON.parse(localStorage.getItem(key));
      localStorage.setItem(key, JSON.stringify(val));
    } catch (e) { return null; }
  }

  /* ---------- Tiroirs ---------- */
  var lastFocus;
  function openDrawer(id) {
    var d = document.getElementById(id);
    if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    var f = d.querySelector('button, a, input');
    if (f) setTimeout(function () { f.focus(); }, 50);
  }
  function closeDrawer(d) {
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open')) document.body.classList.remove('no-scroll');
    if (lastFocus) lastFocus.focus();
  }
  on(document, 'click', function (e) {
    var openBtn = e.target.closest('[data-drawer-open]');
    if (openBtn) { e.preventDefault(); openDrawer(openBtn.getAttribute('data-drawer-open')); return; }
    var closeBtn = e.target.closest('[data-drawer-close]');
    if (closeBtn) { e.preventDefault(); closeDrawer(closeBtn.closest('[data-drawer]')); }
  });
  on(document, 'keydown', function (e) {
    if (e.key === 'Escape') {
      $$('.drawer.is-open').forEach(closeDrawer);
      var lb = $('.lightbox'); if (lb) lb.remove();
    }
  });

  /* ---------- En-tête ---------- */
  var header = $('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 120); };
    on(window, 'scroll', onScroll, { passive: true });
    onScroll();
  }
  on($('[data-search-toggle]'), 'click', function () {
    var ms = $('.header__mobile-search');
    if (!ms) return;
    ms.classList.toggle('is-open');
    var i = ms.querySelector('input'); if (i) i.focus();
  });

  // Méga-menu accessible au clavier / tactile
  $$('.nav__item.has-mega > .nav__link').forEach(function (link) {
    on(link, 'click', function (e) {
      if (window.matchMedia('(hover: none)').matches) {
        var item = link.parentElement;
        if (!item.classList.contains('is-open')) {
          e.preventDefault();
          $$('.nav__item.is-open').forEach(function (i) { i.classList.remove('is-open'); });
          item.classList.add('is-open');
          link.setAttribute('aria-expanded', 'true');
        }
      }
    });
  });

  // Bandeau d'annonces : rotation sur mobile
  (function () {
    var items = $$('.topbar__list--scroll .topbar__item');
    if (items.length < 2) return;
    var i = 0;
    items[0].classList.add('is-current');
    setInterval(function () {
      items[i].classList.remove('is-current');
      i = (i + 1) % items.length;
      items[i].classList.add('is-current');
    }, 3500);
  })();

  /* ---------- Recherche prédictive ---------- */
  $$('[data-predictive-search]').forEach(function (form) {
    var input = form.querySelector('input[type=search]');
    var box = form.querySelector('.predictive');
    var timer, ctrl;
    if (!input || !box) return;
    on(input, 'input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { box.hidden = true; return; }
      timer = setTimeout(function () {
        if (ctrl) ctrl.abort();
        ctrl = window.AbortController ? new AbortController() : null;
        var url = PL.routes.predictiveSearch + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,article&resources[limit]=6&resources[options][fields]=title,product_type,variants.title,vendor,tag';
        fetch(url, ctrl ? { signal: ctrl.signal } : {})
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var res = data.resources.results;
            var html = '';
            (res.products || []).forEach(function (p) {
              html += '<a class="predictive__item" href="' + p.url + '">' +
                (p.featured_image && p.featured_image.url ? '<img src="' + p.featured_image.url + '&width=120" alt="" loading="lazy">' : '') +
                '<div><strong>' + p.title + '</strong><span>' + formatMoney(parseFloat(p.price) * 100) + '</span></div></a>';
            });
            (res.collections || []).forEach(function (c) {
              html += '<a class="predictive__item" href="' + c.url + '"><div><strong>' + c.title + '</strong><small>Collection</small></div></a>';
            });
            (res.articles || []).forEach(function (a) {
              html += '<a class="predictive__item" href="' + a.url + '"><div><strong>' + a.title + '</strong><small>Guide & conseil</small></div></a>';
            });
            if (!html) html = '<p class="predictive__empty">Aucun résultat pour « ' + q.replace(/</g, '&lt;') + ' »</p>';
            else html += '<a class="predictive__all" href="' + PL.routes.search + '?q=' + encodeURIComponent(q) + '&type=product">Voir tous les résultats →</a>';
            box.innerHTML = html;
            box.hidden = false;
          })
          .catch(function () {});
      }, 220);
    });
    on(document, 'click', function (e) { if (!form.contains(e.target)) box.hidden = true; });
  });

  /* ---------- Diaporama ---------- */
  $$('[data-slider]').forEach(function (slider) {
    var slides = $$('[data-slide]', slider);
    var dots = $$('[data-slider-dots] button', slider);
    if (slides.length < 2) return;
    var idx = 0, timer;
    var delay = parseInt(slider.getAttribute('data-autoplay'), 10) || 0;
    function go(n) {
      slides[idx].classList.remove('is-active');
      if (dots[idx]) dots[idx].classList.remove('is-active');
      idx = (n + slides.length) % slides.length;
      slides[idx].classList.add('is-active');
      if (dots[idx]) dots[idx].classList.add('is-active');
    }
    function play() { if (delay) { clearInterval(timer); timer = setInterval(function () { go(idx + 1); }, delay); } }
    on($('[data-slider-next]', slider), 'click', function () { go(idx + 1); play(); });
    on($('[data-slider-prev]', slider), 'click', function () { go(idx - 1); play(); });
    dots.forEach(function (d, i) { on(d, 'click', function () { go(i); play(); }); });
    on(slider, 'mouseenter', function () { clearInterval(timer); });
    on(slider, 'mouseleave', play);
    // Swipe
    var x0 = null;
    on(slider, 'touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    on(slider, 'touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { go(idx + (dx < 0 ? 1 : -1)); play(); }
      x0 = null;
    });
    // Shopify éditeur : afficher le bloc sélectionné
    on(document, 'shopify:block:select', function (e) {
      var i = slides.indexOf(e.target);
      if (i > -1) { go(i); clearInterval(timer); }
    });
    play();
  });

  /* ---------- Carrousels ---------- */
  function initCarousels(scope) {
    $$('[data-carousel]', scope).forEach(function (c) {
      if (c.dataset.ready) return;
      c.dataset.ready = '1';
      var track = $('[data-carousel-track]', c);
      var prev = $('[data-carousel-prev]', c);
      var next = $('[data-carousel-next]', c);
      if (!track) return;
      function update() {
        if (prev) prev.disabled = track.scrollLeft <= 4;
        if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      }
      on(prev, 'click', function () { track.scrollBy({ left: -track.clientWidth * 0.8, behavior: 'smooth' }); });
      on(next, 'click', function () { track.scrollBy({ left: track.clientWidth * 0.8, behavior: 'smooth' }); });
      on(track, 'scroll', update, { passive: true });
      on(window, 'resize', update);
      update();
    });
  }
  initCarousels();

  /* ---------- Quantité +/- ---------- */
  on(document, 'click', function (e) {
    var btn = e.target.closest('[data-qty-minus], [data-qty-plus]');
    if (!btn) return;
    var wrap = btn.closest('[data-qty]');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var min = parseInt(input.min || '0', 10);
    var v = parseInt(input.value || '1', 10) + (btn.hasAttribute('data-qty-plus') ? 1 : -1);
    input.value = Math.max(min, v);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ==========================================================================
     PANIER (AJAX)
     ========================================================================== */
  function cartSectionIds() {
    var ids = ['cart-drawer'];
    var main = $('[data-cart-section]');
    if (main) ids.push(main.getAttribute('data-cart-section'));
    return ids;
  }

  function renderSections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (id) {
      var html = sections[id];
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      if (id === 'cart-drawer') {
        var fresh = doc.querySelector('#CartDrawer .drawer__panel');
        var cur = $('#CartDrawer .drawer__panel');
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
      } else {
        var freshMain = doc.querySelector('[data-cart-section]');
        var curMain = $('[data-cart-section]');
        if (freshMain && curMain) curMain.innerHTML = freshMain.innerHTML;
      }
    });
  }

  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (b) {
      b.textContent = count;
      b.hidden = count === 0;
    });
  }

  function refreshCount() {
    return fetch(PL.routes.cart + '.js').then(function (r) { return r.json(); }).then(function (c) { updateCount(c.item_count); return c; });
  }

  function addToCart(items, btn) {
    if (btn) btn.classList.add('is-loading');
    return fetch(PL.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: cartSectionIds().join(','), sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (res) {
        if (PL.cartType === 'page') { window.location.href = PL.routes.cart; return; }
        renderSections(res.sections);
        refreshCount();
        if (btn) {
          btn.classList.add('is-added');
          setTimeout(function () { btn.classList.remove('is-added'); }, 1500);
        }
        toast(PL.strings.added);
        openDrawer('CartDrawer');
      })
      .catch(function (err) {
        toast((err && (err.description || err.message)) || PL.strings.error);
      })
      .finally(function () { if (btn) btn.classList.remove('is-loading'); });
  }

  on(document, 'submit', function (e) {
    var form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();
    var fd = new FormData(form);
    var id = fd.get('id');
    if (!id) return;
    var item = { id: parseInt(id, 10), quantity: parseInt(fd.get('quantity') || '1', 10) };
    var props = {};
    fd.forEach(function (v, k) { var m = k.match(/^properties\[(.+)\]$/); if (m) props[m[1]] = v; });
    if (Object.keys(props).length) item.properties = props;
    addToCart([item], form.querySelector('[type=submit]'));
  });

  function changeLine(key, qty, row) {
    if (row) row.classList.add('is-loading');
    return fetch(PL.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty, sections: cartSectionIds().join(','), sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status && res.description) toast(res.description);
        renderSections(res.sections);
        updateCount(res.item_count || 0);
      })
      .catch(function () { toast(PL.strings.error); if (row) row.classList.remove('is-loading'); });
  }

  var qtyTimer;
  on(document, 'change', function (e) {
    var input = e.target.closest('[data-line-qty]');
    if (!input) return;
    clearTimeout(qtyTimer);
    qtyTimer = setTimeout(function () {
      changeLine(input.getAttribute('data-line-qty'), Math.max(0, parseInt(input.value, 10) || 0), input.closest('.cline'));
    }, 350);
  });
  on(document, 'click', function (e) {
    var rm = e.target.closest('[data-line-remove]');
    if (rm) { e.preventDefault(); changeLine(rm.getAttribute('data-line-remove'), 0, rm.closest('.cline')); }
    var co = e.target.closest('[data-cart-open]');
    if (co && PL.cartType === 'drawer' && !document.body.classList.contains('template-cart')) { e.preventDefault(); openDrawer('CartDrawer'); }
  });

  // Codes promo : appliqués via /discount/CODE puis retour sur la page
  on(document, 'submit', function (e) {
    var f = e.target.closest('[data-discount-form]');
    if (!f) return;
    e.preventDefault();
    var code = (f.querySelector('input').value || '').trim();
    if (!code) return;
    window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(window.location.pathname === '/' ? PL.routes.cart : window.location.pathname);
  });

  /* ==========================================================================
     FICHE PRODUIT
     ========================================================================== */
  $$('[data-product]').forEach(function (root) {
    var jsonEl = $('[data-product-json]', root);
    var data = jsonEl ? JSON.parse(jsonEl.textContent) : { variants: [] };
    var form = $('#ProductForm', root);
    var idInput = form && $('[data-variant-id]', form);
    var slides = $$('.gallery__slide', root);
    var thumbs = $$('[data-thumb]', root);

    function showMedia(mediaId) {
      if (!mediaId) return;
      slides.forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-media-id') == mediaId); });
      thumbs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-thumb') == mediaId); });
      var at = thumbs.filter(function (t) { return t.classList.contains('is-active'); })[0];
      if (at && at.scrollIntoView) at.parentElement.parentElement.scrollLeft = at.parentElement.offsetLeft - 40;
    }
    function currentIndex() {
      for (var i = 0; i < slides.length; i++) if (slides[i].classList.contains('is-active')) return i;
      return 0;
    }
    function step(d) {
      if (!slides.length) return;
      var n = (currentIndex() + d + slides.length) % slides.length;
      showMedia(slides[n].getAttribute('data-media-id'));
    }
    thumbs.forEach(function (t) { on(t, 'click', function () { showMedia(t.getAttribute('data-thumb')); }); });
    on($('[data-gallery-prev]', root), 'click', function () { step(-1); });
    on($('[data-gallery-next]', root), 'click', function () { step(1); });
    var gx = null, main = $('.gallery__main', root);
    on(main, 'touchstart', function (e) { gx = e.touches[0].clientX; }, { passive: true });
    on(main, 'touchend', function (e) {
      if (gx === null) return;
      var dx = e.changedTouches[0].clientX - gx;
      if (Math.abs(dx) > 40) step(dx < 0 ? 1 : -1);
      gx = null;
    });
    // Zoom / lightbox
    on(root, 'click', function (e) {
      var z = e.target.closest('[data-zoom]');
      if (!z) return;
      e.preventDefault();
      var lb = document.createElement('div');
      lb.className = 'lightbox';
      lb.setAttribute('role', 'dialog');
      lb.innerHTML = '<img src="' + z.getAttribute('href') + '" alt="">';
      on(lb, 'click', function () { lb.remove(); });
      document.body.appendChild(lb);
    });

    // Variantes
    function selectedOptions() {
      return $$('.opt', root).map(function (fs) {
        var c = fs.querySelector('input:checked');
        return c ? c.value : null;
      });
    }
    function findVariant(opts) {
      return data.variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      })[0];
    }
    function updateAvailability(opts) {
      $$('.opt', root).forEach(function (fs, idx) {
        $$('.opt__item', fs).forEach(function (label) {
          var input = label.querySelector('input');
          var test = opts.slice(); test[idx] = input.value;
          var ok = data.variants.some(function (v) {
            return v.available && v.options.every(function (o, i) { return o === test[i]; });
          });
          label.classList.toggle('is-unavailable', !ok);
        });
      });
    }
    function updateVariant() {
      var opts = selectedOptions();
      $$('.opt', root).forEach(function (fs, i) { var s = fs.querySelector('[data-option-value]'); if (s) s.textContent = opts[i]; });
      updateAvailability(opts);
      var v = findVariant(opts);
      var atc = $('[data-atc]', root);
      var label = $('[data-atc-label]', root);
      var stock = $('[data-stock]', root);
      var stockInline = $('[data-stock-inline]', root);
      var sticky = $('[data-sticky-submit]', root);
      if (!v) {
        if (atc) atc.disabled = true;
        if (sticky) sticky.disabled = true;
        if (label) label.textContent = PL.strings.unavailable;
        return;
      }
      if (idInput) idInput.value = v.id;
      if (atc) atc.disabled = !v.available;
      if (sticky) sticky.disabled = !v.available;
      if (label) label.textContent = v.available ? PL.strings.addToCart : PL.strings.soldOut;
      if (stock) {
        stock.classList.toggle('is-out', !v.available);
        stock.innerHTML = '<i></i> ' + (v.available ? 'En stock' : 'Épuisé');
      }
      if (stockInline) stockInline.hidden = !v.available;
      var priceEl = $('.pinfo [data-price]', root);
      if (priceEl) {
        var sale = v.compare_at_price && v.compare_at_price > v.price;
        priceEl.classList.toggle('price--sale', !!sale);
        priceEl.innerHTML = '<span class="price__current">' + formatMoney(v.price) + '</span>' + (sale ? '<s class="price__compare">' + formatMoney(v.compare_at_price) + '</s>' : '');
      }
      var sp = $('[data-sticky-price]', root); if (sp) sp.textContent = formatMoney(v.price);
      var sku = $('[data-sku]', root);
      if (sku) { sku.textContent = v.sku || ''; sku.parentElement.hidden = !v.sku; }
      if (v.media_id) showMedia(v.media_id);
      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    $$('.opt input', root).forEach(function (i) { on(i, 'change', updateVariant); });
    if ($$('.opt', root).length) updateAvailability(selectedOptions());

    // Onglets
    var tabs = $$('[role=tab]', root);
    tabs.forEach(function (tab) {
      on(tab, 'click', function () {
        tabs.forEach(function (t) {
          var active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active);
          var p = document.getElementById(t.getAttribute('aria-controls'));
          if (p) { p.hidden = !active; p.classList.toggle('is-active', active); }
        });
      });
    });

    // Barre d'achat fixe (mobile)
    var stickyBar = $('[data-sticky-atc]', root);
    var atcBtn = $('[data-atc]', root);
    if (stickyBar && atcBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        stickyBar.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
      }).observe(atcBtn);
      on($('[data-sticky-submit]', stickyBar), 'click', function () {
        if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      });
    }
  });

  /* ---------- Recommandations produits ---------- */
  $$('[data-recommendations][data-url]').forEach(function (el) {
    fetch(el.getAttribute('data-url'))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.querySelector('.card')) {
          el.innerHTML = fresh.innerHTML;
          initCarousels(el);
          syncWishlistButtons();
        } else if (!el.querySelector('.card')) {
          el.hidden = true;
        }
      })
      .catch(function () {});
  });

  /* ==========================================================================
     COLLECTION : filtres & tri
     ========================================================================== */
  var filterForm = $('[data-filter-form]');
  function applyFilters() {
    if (!filterForm) return;
    var fd = new FormData(filterForm);
    var params = new URLSearchParams();
    fd.forEach(function (v, k) { if (v !== '') params.append(k, v); });
    var sort = $('[data-sort]');
    if (sort) params.set('sort_by', sort.value);
    window.location.search = params.toString();
  }
  if (filterForm) {
    var desktop = window.matchMedia('(min-width: 990px)');
    on(filterForm, 'change', function (e) {
      if (e.target.matches('[data-range-min],[data-range-max],[data-filter-search]')) return;
      if (desktop.matches) applyFilters();
    });
    on(filterForm, 'submit', function (e) { e.preventDefault(); applyFilters(); });

    $$('[data-price-range]', filterForm).forEach(function (pr) {
      var rMin = $('[data-range-min]', pr), rMax = $('[data-range-max]', pr);
      var iMin = $('[data-input-min]', pr), iMax = $('[data-input-max]', pr);
      var bar = $('.price-range__sliders', pr);
      var max = parseFloat(rMax.max) || 1;
      function paint() {
        bar.style.setProperty('--from', (rMin.value / max * 100) + '%');
        bar.style.setProperty('--to', (rMax.value / max * 100) + '%');
      }
      on(rMin, 'input', function () { if (+rMin.value > +rMax.value) rMin.value = rMax.value; iMin.value = rMin.value; paint(); });
      on(rMax, 'input', function () { if (+rMax.value < +rMin.value) rMax.value = rMin.value; iMax.value = rMax.value; paint(); });
      [rMin, rMax].forEach(function (r) { on(r, 'change', function () { if (desktop.matches) applyFilters(); }); });
      on(iMin, 'input', function () { rMin.value = iMin.value || 0; paint(); });
      on(iMax, 'input', function () { rMax.value = iMax.value || max; paint(); });
      paint();
    });

    $$('[data-filter-search]', filterForm).forEach(function (s) {
      on(s, 'input', function () {
        var q = s.value.toLowerCase();
        var list = s.nextElementSibling;
        list.classList.toggle('is-collapsed', !q);
        $$('.check', list).forEach(function (c) { c.hidden = q && c.textContent.toLowerCase().indexOf(q) === -1; });
      });
    });
    $$('[data-filter-more]', filterForm).forEach(function (b) {
      on(b, 'click', function () {
        var list = b.previousElementSibling;
        var collapsed = list.classList.toggle('is-collapsed');
        b.textContent = collapsed ? 'Voir plus' : 'Voir moins';
      });
    });
  }
  on($('[data-sort]'), 'change', function (e) {
    if (filterForm) applyFilters();
    else { var u = new URL(location.href); u.searchParams.set('sort_by', e.target.value); location.href = u; }
  });
  $$('[data-view]').forEach(function (b) {
    on(b, 'click', function () {
      $$('[data-view]').forEach(function (x) { x.classList.toggle('is-active', x === b); });
      var g = $('[data-product-grid]');
      if (g) g.classList.toggle('is-list', b.getAttribute('data-view') === 'list');
      storage('pl-view', b.getAttribute('data-view'));
    });
  });
  if (storage('pl-view') === 'list') { var lb = $('[data-view="list"]'); if (lb) lb.click(); }

  /* ==========================================================================
     FAVORIS (localStorage)
     ========================================================================== */
  var WKEY = 'puffland-wishlist';
  function getWishlist() { return storage(WKEY) || []; }
  function setWishlist(list) { storage(WKEY, list); syncWishlistButtons(); }

  function syncWishlistButtons() {
    var list = getWishlist();
    $$('[data-wishlist-toggle]').forEach(function (b) {
      var active = list.indexOf(b.getAttribute('data-wishlist-toggle')) > -1;
      b.classList.toggle('is-active', active);
      b.setAttribute('aria-pressed', active);
    });
    $$('[data-wishlist-count]').forEach(function (c) { c.textContent = list.length; c.hidden = list.length === 0; });
    $$('[data-wishlist-count-plain]').forEach(function (c) { c.textContent = list.length; });
  }

  on(document, 'click', function (e) {
    var b = e.target.closest('[data-wishlist-toggle]');
    if (!b) return;
    e.preventDefault();
    var h = b.getAttribute('data-wishlist-toggle');
    var list = getWishlist();
    var i = list.indexOf(h);
    if (i > -1) { list.splice(i, 1); toast(PL.strings.wishlistRemoved); }
    else { list.unshift(h); toast(PL.strings.wishlistAdded); }
    b.classList.add('is-pop');
    setTimeout(function () { b.classList.remove('is-pop'); }, 400);
    setWishlist(list);
    var page = $('[data-wishlist-page]');
    if (page && i > -1) {
      var item = page.querySelector('[data-wishlist-item="' + h + '"]');
      if (item) item.remove();
      updateWishlistPage();
    }
  });

  function updateWishlistPage() {
    var page = $('[data-wishlist-page]');
    if (!page) return;
    var n = $$('[data-wishlist-item]', page).length;
    var total = $('[data-wishlist-total]', page);
    if (total) total.textContent = '(' + n + ' produit' + (n > 1 ? 's' : '') + ')';
    var addAll = $('[data-wishlist-addall]', page);
    if (addAll) addAll.hidden = n === 0;
  }

  (function wishlistPage() {
    var page = $('[data-wishlist-page]');
    if (!page) return;
    var grid = $('[data-wishlist-grid]', page);
    var list = getWishlist();
    var root = (PL.routes.root || '/').replace(/\/$/, '');
    Promise.all(list.map(function (h) {
      return fetch(root + '/products/' + encodeURIComponent(h) + '?view=card')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; });
    })).then(function (htmls) {
      var valid = [];
      htmls.forEach(function (html, i) {
        if (html && html.indexOf('data-wishlist-item') > -1) { grid.insertAdjacentHTML('beforeend', html); valid.push(list[i]); }
      });
      if (valid.length !== list.length) storage(WKEY, valid);
      syncWishlistButtons();
      updateWishlistPage();
    });
    on($('[data-wishlist-addall]', page), 'click', function (e) {
      var items = $$('[data-product-card]', grid)
        .filter(function (c) { return c.getAttribute('data-available') === 'true'; })
        .map(function (c) { return { id: parseInt(c.getAttribute('data-variant'), 10), quantity: 1 }; });
      if (items.length) addToCart(items, e.currentTarget);
    });
  })();

  syncWishlistButtons();
  on(window, 'storage', function (e) { if (e.key === WKEY) syncWishlistButtons(); });

  /* ---------- Vérification de l'âge ---------- */
  (function () {
    var gate = $('#AgeGate');
    if (!gate) return;
    if (window.Shopify && window.Shopify.designMode) return;
    if (storage('puffland-age-ok')) return;
    gate.hidden = false;
    document.body.classList.add('no-scroll');
    on($('[data-age-confirm]', gate), 'click', function () {
      storage('puffland-age-ok', true);
      gate.hidden = true;
      document.body.classList.remove('no-scroll');
    });
  })();

  /* ---------- Compte client ---------- */
  $$('[data-toggle-recover]').forEach(function (a) {
    on(a, 'click', function (e) {
      e.preventDefault();
      var l = $('#LoginBox'), r = $('#RecoverBox');
      if (l && r) { l.hidden = !l.hidden; r.hidden = !r.hidden; }
    });
  });
  if (location.hash === '#recover') { var l0 = $('#LoginBox'), r0 = $('#RecoverBox'); if (l0 && r0) { l0.hidden = true; r0.hidden = false; } }
  $$('[data-toggle-target]').forEach(function (b) {
    on(b, 'click', function () { var t = document.getElementById(b.getAttribute('data-toggle-target')); if (t) t.hidden = !t.hidden; });
  });
  $$('select[data-default]').forEach(function (s) { var d = s.getAttribute('data-default'); if (d) s.value = d; });

  /* ---------- Éditeur de thème ---------- */
  on(document, 'shopify:section:load', function (e) { initCarousels(e.target); syncWishlistButtons(); });
})();
